export const LOCALSTORAGE_TEMPLATE_CREATE_KEY = "createFromTemplateKey";

export const UNIFIED_TEMPLATES_API_PATH = "/api/templates/v1";

/**
 * Number of templates shown on a gallery page's curated (unfiltered) view. This
 * is an editorial cap, not a technical one — the Starter Kit pages are designed
 * around showing a hand-picked subset.
 */
export const GALLERY_CURATED_LIMIT = 27;

/**
 * GROWEXP-267: when a category or app filter is active the view is a catch-all
 * browse, so the editorial cap must not apply. Bounded rather than unlimited to
 * keep the grid renderable — the largest navigation category is currently 45
 * templates, so this leaves roughly 2x headroom. Note the Templates API
 * defaults to 10 when no limit is sent, so this must be passed explicitly.
 */
export const GALLERY_FILTERED_LIMIT = 100;
